import { useState } from 'react'
import {
  PopoverArrow,
  PopoverBody,
  PopoverCloseTrigger,
  PopoverContent,
  PopoverFooter,
  PopoverRoot,
  PopoverTitle,
  PopoverTrigger
} from '@/components/ui/popover'
import { Popover, Portal } from '@chakra-ui/react'

// TODO: Refactor to use "Popover." components from Chakra UI directly
export default function SimplePopover ({ on, closeOnBlur, contentProps, trigger, header, body, footer }) {
  const [open, setOpen] = useState(false)

  return (
    <PopoverRoot open={open} onOpenChange={(e) => setOpen(e.open)} closeOnInteractionOutside={closeOnBlur}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent bg='bg.surface' borderColor='border.default' color='fg.default' {...contentProps}>
        <PopoverCloseTrigger />
        <PopoverArrow />
        <PopoverBody style={{ overflowY: 'auto' }}>
          {header && <PopoverTitle fontWeight='bold' mb={5}>{header}</PopoverTitle>}
          {body}
        </PopoverBody>
        {footer && <PopoverFooter borderTopColor='border.muted'>{footer}</PopoverFooter>}
      </PopoverContent>
    </PopoverRoot>
  )
}

export function ControlledPopover ({ closeOnBlur, isOpen, onClose, contentProps, trigger, header, body, footer, portalRef }) {
  return (
    <Popover.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()} closeOnInteractionOutside={closeOnBlur}>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>
      <Portal container={portalRef}>
        <Popover.Positioner>
          <Popover.Content {...contentProps}>
            <Popover.Arrow />
            <Popover.Body>
              {header && <Popover.Title mb={5}>{header}</Popover.Title>}
              {body}
            </Popover.Body>
            {footer && <Popover.Footer>{footer}</Popover.Footer>}
            <PopoverCloseTrigger />
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  )
}
